import postAPI from './postAPI.js'

export default async function getTaskFlowDetails(taskFlowId) {
    const data = await postAPI('taskflows/get', { id: taskFlowId });
    return data;
}
